import gql from 'graphql-tag';

const guaranteeForceOrdersQuery = gql`
  query GuaranteeForceOrders($productCode: String!, $vin: String!) {
    guaranteeForceOrders(productCode: $productCode, vin: $vin) {
      orderId
      vin
      sellerAccountNumber
      productOrderState
      ineligibilityType
      createdAt
      updatedAt
    }
  }
`;

export default guaranteeForceOrdersQuery;
